module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/th/4-4b30b34ad6ce66e7356d93e157498315.jpg";